import { useCallback, useRef, useState } from 'react';
const CLOSED_STATE = {
  anchorEl: null,
  onInsert: null,
  onDismiss: null
};
export function useVariablePicker() {
  const [pickerState, setPickerState] = useState(CLOSED_STATE);
  const dismissRef = useRef(null);
  const openPicker = useCallback((anchorEl, onInsert, onDismiss) => {
    var _dismissRef$current;
    (_dismissRef$current = dismissRef.current) === null || _dismissRef$current === void 0 || _dismissRef$current.call(dismissRef);
    dismissRef.current = onDismiss !== null && onDismiss !== void 0 ? onDismiss : null;
    setPickerState({
      anchorEl,
      onInsert,
      onDismiss: onDismiss !== null && onDismiss !== void 0 ? onDismiss : null
    });
  }, []);
  const closePicker = useCallback(() => {
    dismissRef.current = null;
    setPickerState(CLOSED_STATE);
  }, []);
  return {
    pickerState,
    openPicker,
    closePicker
  };
}